module.exports = __webpack_public_path__ + "img/malta.0c830dd6.png";